import React from 'react';
import styled from 'styled-components';
import { tokens } from '../../config/themeTokens';

const StyledText = styled.p`
  font-family: ${tokens.typography.fontFamily};
  font-size: ${tokens.typography.sizeBase};
  line-height: 1.6;
  color: ${({ $muted }) => ($muted ? tokens.colors.textMuted : tokens.colors.text)};
  margin: 0 0 ${tokens.spacing.md};
`;

export function Text({ muted, children, ...props }) {
  return (
    <StyledText $muted={muted} {...props}>
      {children}
    </StyledText>
  );
}

export default Text;
